import { Common } from './common';

import { CreateValues } from './models/careGapFindings';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async createBulk(
    values: CreateValues[],
  ): Promise<{ status: number; message?: string | undefined }> {
    const url = this.common.constructPath('/care-gap-findings/create');
    return this.common.postJSON(url, { careGapFindings: values });
  }

  async findAllByPatientDocumentId(
    patientDocumentId: string,
  ): Promise<{ careGapFindings: CreateValues[] }> {
    const url = this.common.constructPath('/care-gap-findings/find', {
      patientDocumentId,
    });
    return this.common.getJSON(url);
  }
}
